import React from 'react';
import { M22BrandsModule } from '~/lib';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer';
import { Link } from '~/shared/components';
import Flex from '~/shared/components/Flex';
import styles from './M22Brands.module.scss';
import { MaxWidth } from '~/shared/components/MaxWidth';
import clsx from 'clsx';
import BrandCarousel from './BrandCarousel/BrandCarousel';
import Typography from '~/shared/components/Typography/Typography';

export const M22Brands: React.FC<M22BrandsModule> = ({
    items,
    headline,
    priority,
    callToAction,
    backgroundColor,
    isLastItem,
    ...rest
}) => {
    return (
        <ModuleContainer
            className={clsx(styles.brandsContainer, {
                [styles.noPadding]: !headline || !callToAction?.url,
            })}
            {...rest}
            style={
                {
                    ['--background-color']: backgroundColor,
                } as React.CSSProperties
            }
        >
            {headline && callToAction?.url && (
                <div className={styles.headlineWrapper}>
                    <MaxWidth>
                        <Flex
                            className={styles.headlineFlex}
                            alignItems="center"
                            justifyContent="space-between"
                            grow
                        >
                            <Typography
                                className={styles.headline}
                                variant={'title-S'}
                                as="h2"
                                data-testid="StyledHeadline"
                            >
                                <span>{headline}</span>
                            </Typography>

                            <div className={styles.buttonContainer}>
                                <Link
                                    className={styles.brandsLink}
                                    aria-label={callToAction?.title || 'Card Link'}
                                    href={callToAction?.url}
                                    noHover
                                    target={callToAction?.target}
                                >
                                    {callToAction?.text}
                                </Link>
                            </div>
                        </Flex>
                    </MaxWidth>
                </div>
            )}
            <div className={styles.cardCarouselContainer}>
                <BrandCarousel
                    isSkipHidden={isLastItem}
                    priority={priority}
                    items={items ? items : []}
                />
            </div>
        </ModuleContainer>
    );
};
